module.exports = __webpack_public_path__ + "static/media/Korea_Exhibition_03.e19a060b.png";